import type { CountryConfigMap } from '../auth-config-types'

/**
 * North America Entra External ID (GMCIAMPROD) — parallel to B2C in production.config.ts.
 * `mapAuthority` is the CIAM tenant root on `ciamlogin.gm.com` (no trailing `/v2.0`); MSAL appends `/v2.0` for OIDC discovery. Not `login.microsoftonline.com`.
 * `mapPolicy` is unused for Entra (no B2C user-flow name). `mapClientId`: US/MX per market; **Canada prod** uses the same app id as US. **Canada preprod** Entra app id lives only in `na-entra-external-id-preproduction.config.ts`.
 */
export const naEntraExternalIdProductionConfig: Pick<CountryConfigMap, 'US' | 'CA' | 'MX'> = {
	US: {
		en: {
			mapTenant: 'ciamlogin.gm.com',
			mapAuthority: 'https://ciamlogin.gm.com/ec1eeb88-cfcd-4735-9b8a-a0e63fd6d5ec',
			mapPolicy: '',
			mapClientId: '43b9895e-a54a-412e-b11d-eaf11dac570d',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['ciamlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountMissingInfoURL: '',
				MyAccountVehicleURL: '/ownercenter/api/garagesummary',
				NotificationInboxURL: '/notif/delivery/inbox/v1/customer',
				logoutURL: location.origin,
			},
		},
	},
	CA: {
		en: {
			mapTenant: 'ciamlogin.gm.com',
			mapAuthority: 'https://ciamlogin.gm.com/ec1eeb88-cfcd-4735-9b8a-a0e63fd6d5ec',
			mapPolicy: '',
			mapClientId: '43b9895e-a54a-412e-b11d-eaf11dac570d',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['ciamlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/en',
			urls: {
				MyAccountProfileURL: '/en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '/en/ownercenter/api/garagesummary',
				MyAccountMissingInfoURL: '/en/ownercenter/api/checkMissingInfo',
				NotificationInboxURL: '/en/notif/delivery/inbox/v1/customer',
				logoutURL: location.origin + '/en',
			},
		},
		fr: {
			mapTenant: 'ciamlogin.gm.com',
			mapAuthority: 'https://ciamlogin.gm.com/ec1eeb88-cfcd-4735-9b8a-a0e63fd6d5ec',
			mapPolicy: '',
			mapClientId: '43b9895e-a54a-412e-b11d-eaf11dac570d',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['ciamlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/fr',
			urls: {
				MyAccountProfileURL: '/fr/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '/fr/ownercenter/api/garagesummary',
				MyAccountMissingInfoURL: '/fr/ownercenter/api/checkMissingInfo',
				NotificationInboxURL: '/fr/notif/delivery/inbox/v1/customer',
				logoutURL: location.origin + '/fr',
			},
		},
	},
	MX: {
		es: {
			mapTenant: 'ciamlogin.gm.com',
			mapAuthority: 'https://ciamlogin.gm.com/ec1eeb88-cfcd-4735-9b8a-a0e63fd6d5ec',
			mapPolicy: '',
			mapClientId: '19144e1e-0456-4333-831b-713c7176ce45',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['ciamlogin.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin,
			},
		},
	},
}
